const getDefaultState = () => {
  return {
    params: {
      data_inicio: {
        value: '',
        visible: false,
      },
      data_fim: {
        value: '',
        visible: false,
      },
      gate: {
        value: '',
        visible: false,
      },
      parceiro: {
        value: '',
        visible: false,
      },
      proprietario: {
        value: '',
        visible: false,
      },
      terminal: {
        value: '',
        visible: false,
      },
      servico: {
        value: null,
        visible: false,
      },
    },
  }
}

export const resumoMovimentacao = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
      localStorage.setItem(
        'filterOptionsDetailsResumoMovimentacao',
        JSON.stringify(state.params)
      )
    },
    UPDATE_PARAMS(state, params) {
      state.params = params
    },
  },
}
